import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import SafeIcon from '../common/SafeIcon';
import { FiExternalLink, FiClock } from 'react-icons/fi';

const ArticleCard = ({ article }) => {
  const timeAgo = (() => {
    try {
      return formatDistanceToNow(new Date(article.pubDate), { addSuffix: true });
    } catch (e) {
      return 'Recently';
    }
  })();

  return (
    <article className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 transition-all hover:shadow-xl hover:border-[#FF0000]/30 flex flex-col h-full group relative overflow-hidden">
      <div className="absolute top-0 left-0 w-1 h-full bg-black group-hover:bg-[#FF0000] transition-colors"></div>
      
      <div className="flex items-center justify-between mb-4">
        <span className="text-[10px] font-black uppercase tracking-widest px-2 py-1 bg-gray-100 text-gray-800 rounded">
          {article.sourceName}
        </span>
        <div className="flex items-center text-xs font-medium text-gray-400">
          <SafeIcon icon={FiClock} className="mr-1" />
          <span>{timeAgo}</span>
        </div>
      </div>

      <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-[#FF0000] transition-colors leading-tight">
        <a href={article.link} target="_blank" rel="noopener noreferrer">
          {article.title}
        </a>
      </h3>

      <p className="text-sm text-gray-600 mb-6 line-clamp-3 flex-grow leading-relaxed">
        {article.excerpt || 'No summary available.'}
      </p>

      <div className="mt-auto pt-4 border-t border-gray-50 flex justify-end">
        <a
          href={article.link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center text-xs font-black uppercase tracking-tighter text-black hover:text-[#FF0000] transition-colors"
        >
          Read Article
          <SafeIcon icon={FiExternalLink} className="ml-1.5 w-3 h-3" />
        </a>
      </div>
    </article>
  );
};

export default ArticleCard;